import type { PublicProject } from '@/api/public-projects';

type DonationTarget = Pick<PublicProject, 'slug' | 'id' | 'organizationId'>;

export const projectDonationHref = (project: DonationTarget): string =>
  `/give/${encodeURIComponent(project.organizationId)}/${encodeURIComponent(project.id)}`;

export const organizationAppHref = (slug: string): string => `/app?org=${encodeURIComponent(slug)}`;

export const organizationFundHref = (slug: string, fund: 'tithe' | 'general-fund'): string =>
  `/give/fund/${encodeURIComponent(slug)}/${fund}`;
